import { useTranslationWithPrefix } from '@hotjar/translations';
import { PlanColumnStyles as S } from './styles';

interface Props {
  coveragePercentage: number;
  trafficCoverageLabel?: string;
  maxTrafficCoverageLabel?: string;
  hideTrafficNumber?: boolean;
  className?: string;
}

export const PlanTrafficCoverageLabel = ({
  coveragePercentage,
  trafficCoverageLabel,
  maxTrafficCoverageLabel,
  hideTrafficNumber,
  className,
}: Props): JSX.Element => {
  const { t } = useTranslationWithPrefix('billing:upsell.plan-traffic-coverage-label');

  if (hideTrafficNumber) {
    return <S.MaxTrafficCoverageWrapper className={className} />;
  }

  if (coveragePercentage === 100) {
    return (
      <S.MaxTrafficCoverageWrapper className={className}>
        <S.MaxTrafficCoverageIcon icon="selected" color="text_success" inline />
        <S.MaxTrafficCoverageLabel>
          {maxTrafficCoverageLabel || t('maximum-traffic-coverage-label')}
        </S.MaxTrafficCoverageLabel>
      </S.MaxTrafficCoverageWrapper>
    );
  }

  return (
    <S.TrafficCoverageLabel className={className}>{trafficCoverageLabel}</S.TrafficCoverageLabel>
  );
};
